import { CmsMeta } from '../cmsMeta';
import './CmsMostBought.css';
import { useTranslation } from '../../../i18n/i18n';
import { Res, useApi } from '../../../state/api';
import { useSession } from '../../../state/session';
import { ErrorMessage } from '../../ErrorMessage/ErrorMessage';
import { ProductListing } from '../../../components/ProductListing/ProductListing';
import { Loader } from '../../../components/Loader/Loader';
import { ButtonLink } from '../../../components/Form/Button';

export const CmsMostBought = () => {
	const { isLoggedIn, user } = useSession();
	const { data: mostBought, error } = useApi(isLoggedIn ? Res.mostBought : null, {});
	const t = { ...useTranslation().generic, ...useTranslation().product };
	const tRoutes = useTranslation().routes;

	if (!isLoggedIn || !user) return <></>;
	if (error && !mostBought) return <ErrorMessage></ErrorMessage>;

	if (!mostBought) return <Loader size="line" />;

	const limit = 8;
	const showMore = mostBought.length > limit;
	const mostBoughtVisible = mostBought.length > limit ? mostBought.slice(0, limit) : mostBought;

	return (
		<div className="cms-most-bought">
			{mostBought.length > 0 && <h2>{t.mostBoughtProducts}</h2>}
			<ProductListing products={mostBoughtVisible}></ProductListing>
			{showMore && (
				<center>
					<ButtonLink linkTo={tRoutes.previouslyBought}>{t.viewMore}</ButtonLink>
				</center>
			)}
		</div>
	);
};

export const cmsMeta: CmsMeta = {
	description: 'What this customer buys most often, so it is empty for a visitor who is not signed in.',
	example: ['CmsMostBought', { index: 4 }],
};
